/**
 * 딥링크 중간 화면 (/deeplink?code=&app=) — 열리자마자 앱을 부르고, 안 열리면 스토어로.
 * 컨트롤러가 app(JB/BD)별로 딥링크 주소·스토어·웹 화면을 정해 #page-data 로 넘긴다 (.env: G5_DEEPLINK_JB, G5_DEEPLINK_BD)
 *   code  — 페이지 코드 (001:알림, 002:수주, ...)
 *   app   — 대상 앱 (JB/BD)
 *   link  — 딥링크 주소, 쿼리 앞까지 (jbbuller://jbbuller.kr / co.kr.badcall://app)
 *   store — 미설치 폴백 스토어 URL (플레이스토어 / 원스토어)
 *   web   — 그 코드의 웹 화면 (AppRegistry::pagePath)
 */
export default class Deeplink {
    initialize() {
        this.d = JSON.parse(document.getElementById('page-data')?.textContent || '{}');
        const ua = navigator.userAgent || navigator.vendor || '';
        this.isAndroid = /android/i.test(ua);

        $('#dl-open').on('click', () => this.openApp());
        // 페이지 로드 시 자동으로 앱 열기 실행 — 짧은 지연 후 (UX 개선)
        $('#loading').show();
        setTimeout(() => this.openApp(), 500);
    }

    openApp() {
        const { code, app, link, store, web } = this.d;
        // 커스텀 스킴은 안드로이드 앱만 받는다. 아이폰·PC 는 그 화면을 웹으로 연다
        // (스토어 주소가 안드로이드 것뿐이라 스토어로 보내면 아이폰 사용자가 Play 웹페이지에 떨어진다)
        if (!this.isAndroid) {
            location.replace(web);
            return;
        }
        // 설치 시: 커스텀 스킴(link?code=&app=)으로 앱 호출
        //   → 앱이 callbackBroker('deeplink', {code, app}) 로 웹 JS 의 deeplink() 실행
        // 미설치 시: 1.5초 내 화면 전환이 없으면 스토어로 폴백
        const deepLink = `${link}?code=${encodeURIComponent(code)}&app=${encodeURIComponent(app)}`;
        const now = Date.now();
        window.location = deepLink;
        setTimeout(() => {
            if (Date.now() - now < 1800) {
                window.location = store;
            }
        }, 1500);
    }
}
